class Machine {

    constructor(result) {

        this.id = +(result.id); // Database-id
        this.machine_id = String(result.machine_id).trim();

        this.status = +(result.status);
        this.machine_order = (result.machine_order);
        this.last_seen = +(result.last_seen);
        this.last_operation = +(result.last_operation);
        this.time_offset = +(result.time_offset);
        this.bde_status = +(result.bde_status);
        this.id_company = +(result.id_company);
        this.id_datacollector = (result.id_datacollector);
        this.id_location = +(result.id_location);
        this.type = (result.type);
        this.alias = (result.alias);
        this.headManuallyOverwritten = ((result.heads_manually_overwritten !== null) ? +(result.heads_manually_overwritten) : null);
        this.heads = +(result.heads);
        this.f_heads_conf = +(result.f_heads_conf);
        this.needles = +(result.needles);
        this.active_needle = +(result.active_needle);
        this.head_type = +(result.head_type);
        this.w_heads_detected = +(result.w_heads_detected);
        this.w_heads_conf = +(result.w_heads_conf);
        this.k_heads_detected = +(result.k_heads_detected);
        this.k_heads_conf = +(result.k_heads_conf);
        this.passes_pattern = +(result.passes_pattern);
        this.pattern_number = (result.pattern_number);
        this.pattern_stitchcounter = +(result.pattern_stitchcounter);
        this.pattern_stitchnumber = +(result.pattern_stitchnumber);
        this.rotation_speed = +(result.rotation_speed);
        this.repeated_pattern = +(result.repeated_pattern);
        this.should_repeat_pattern = +(result.should_repeat_pattern);
        this.stitch_counter = +(result.stitch_counter);
        this.stitch_type = +(result.stitch_type);
        this.user_idcode = (result.user_idcode);
        this.id_operator = (result.id_operator);
        this.operator_name = (result.operator_name);
        this.id_token = (result.id_token);
        this.maintenance = +(result.maintenance);
        this.date_deleted = +(result.date_deleted);
        this.operator_type = (result.operator_type);
        this.head_spacing_ff = +(result.head_spacing_ff);
        this.head_spacing_fw = +(result.head_spacing_fw);
        this.head_spacing_fk = +(result.head_spacing_fk);
        this.settings_pail = +(result.settings_pail);
        this.settings_loop_dir = +(result.settings_loop_dir);
        this.settings_driller = +(result.settings_driller);
        this.settings_soutage = +(result.settings_soutage);
        this.hide_machine = result.hide_machine;
        this.pail_version_left = (result.pail_version_left);
        this.pail_version_right = (result.pail_version_right);
        this.bobbin_case_vers = (result.bobbin_case_vers);
        this.wire_cutter_vers = (result.wire_cutter_vers);
        this.wire_provider_version = (result.wire_provider_version);
        this.cloth_pull_v1_vers = (result.cloth_pull_v1_vers);
        this.cloth_pull_v2_vers = (result.cloth_pull_v2_vers);
        this.active_rfid = +(result.active_rfid);
        this.active_heads = (result.active_heads);
        this.machine_rpm = +(result.machine_rpm);
        this.t8_os_version = (result.t8_os_version);
        this.t8_ts_version = (result.t8_ts_version);
        this.cpu_version = (result.cpu_version);

    }

    getLabel() {

        return this.alias ? this.alias : this.machine_id;

    }

    getHeads() {

        if (this.headManuallyOverwritten > 0) return this.headManuallyOverwritten;
        if (this.heads > 0) return this.heads;
        if (this.w_heads_detected > 0) return this.w_heads_detected;
        if (this.k_heads_detected > 0) return this.k_heads_detected;

        return 1;

    }

    getNeedles() {

        if (this.needles > 0) return this.needles;

        return 1;

    }

}

export default Machine;